var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"c-article__text"},[_c('div',{staticClass:"u-6/10@tablet u-push-2/10@tablet",domProps:{"innerHTML":_vm._s(_vm.content.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }